/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccessRight
 */
export interface AccessRight {
    /**
     * 
     * @type {string}
     * @memberof AccessRight
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessRight
     */
    value?: AccessRightValueEnum;
}


/**
 * @export
 */
export const AccessRightValueEnum = {
    Allow: 'Allow',
    Deny: 'Deny',
    DontCare: 'DontCare'
} as const;
export type AccessRightValueEnum = typeof AccessRightValueEnum[keyof typeof AccessRightValueEnum];


/**
 * Check if a given object implements the AccessRight interface.
 */
export function instanceOfAccessRight(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AccessRightFromJSON(json: any): AccessRight {
    return AccessRightFromJSONTyped(json, false);
}

export function AccessRightFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccessRight {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function AccessRightToJSON(value?: AccessRight | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'value': value.value,
    };
}

